import {
    CREATE_USER_IMPERSONATION,
    CREATE_USER_IMPERSONATION_FAILURE,
} from 'store/actions/types';

export const createUserImpersonation = (payload) => {
    return {
        type: CREATE_USER_IMPERSONATION,
        payload: payload,
    };
};

export const createUserImpersonationFailure = (error) => {
    return {
        type: CREATE_USER_IMPERSONATION_FAILURE,
        error: error,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/users/impersonation/createUserImpersonation.js